import React from "react";
import "./loginwithgoogle.scss";
import GoogleIcon from "../../assets/icons/google.svg";
import { useDispatch } from "react-redux";
import { googleLogin } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { setFocusedProject, setSelectedProject } from "../../store/slices/projectSlice";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import toast from "react-hot-toast";

export default function Loginwithgoogle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const result = await dispatch(googleLogin({
        token: credentialResponse.credential,
      }));

      if (result?.payload?.data?.success) {
        dispatch(setFocusedProject(result?.payload?.data?.data?.project));
        dispatch(setSelectedProject(result?.payload?.data?.data?.project));
        navigate("/");
      }
    } catch (error) {
      toast.error("Google sign in failed");
    }
  };

  const handleGoogleError = () => {
    toast.error("Google sign in failed. Please try again.");
  };

  // Check if Google Client ID is configured
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!googleClientId) {
    // Fallback: Show disabled button if Google OAuth is not configured
    return (
      <div className="login-with-google">
        <button
          onClick={() => toast.error("Google Sign In requires REACT_APP_GOOGLE_CLIENT_ID to be configured")}
          style={{ opacity: 0.6 }}
        >
          <img src={GoogleIcon} alt="GoogleIcon" />
          <span>Google</span>
        </button>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="login-with-google">
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          useOneTap
          shape="rectangular"
          text="continue_with"
          theme="outline"
        />
      </div>
    </GoogleOAuthProvider>
  );
}

